<template>
  <div>
    <noscript>
      <div>
        <img :src="`https://mc.yandex.ru/watch/${metrikaId}`" style="position:absolute; left:-9999px;" alt="" />
      </div>
    </noscript>
  </div>
</template>

<script>
import { config } from '../config';

export default {
  name: 'YandexMetrika',
  data() {
    return {
      metrikaId: config.yandexMetrikaId
    }
  },
  mounted() {
    const tagSrc = `https://mc.yandex.ru/metrika/tag.js?id=${this.metrikaId}`;
    (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
    m[i].l=1*new Date();
    for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
    k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
    (window, document, "script", tagSrc, "ym");

    ym(this.metrikaId, "init", {
      ssr: true,
      webvisor: true,
      clickmap: true,
      ecommerce: "dataLayer",
      referrer: document.referrer,
      url: location.href,
      accurateTrackBounce: true,
      trackLinks: true,
    });
  }
}
</script> 